import { FC } from 'react'

const InfoIcon: FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10ZM18.75 10C18.75 14.8325 14.8325 18.75 10 18.75C5.16751 18.75 1.25 14.8325 1.25 10C1.25 5.16751 5.16751 1.25 10 1.25C14.8325 1.25 18.75 5.16751 18.75 10Z"
      fill="#575757"
    />
    <circle
      cx="10"
      cy="6.25"
      r="1.25"
      fill="#575757"
    />
    <rect
      x="8.75"
      y="8.75"
      width="2.5"
      height="6.25"
      rx="1.25"
      fill="#575757"
    />
  </svg>
)

export default InfoIcon
